import React from 'react';
import '../../../styles/pulse.scss';
import { Paragraph, Button } from 'prixa-design-kit/dist';

export const NoDoctor = () => {
  return (
    <div style={{ textAlign: 'center' }}>
      <img
        loading="lazy"
        alt="no-doc"
        src={`${process.env.REACT_APP_ASSET_URL}/telemed/Tidak%20Menemukan%20Dokter.png`}
        width="100%"
      />
      <Paragraph scale="content" style={{ fontSize: '16px', textAlign: 'center', margin: '-5vh 58px 10vh' }}>
        Mohon maaf, belum ada dokter yang tersedia saat ini.
      </Paragraph>
      <Button
        onClick={() => {
          window.location.reload();
        }}
        size="xLarge"
        variant="primary"
      >
        Coba Lagi
      </Button>
    </div>
  );
};
